import { Avatar, Button, CircularProgress, Card, CardContent, Chip, Divider, Fab, Tab, Tabs, Grid, Tooltip, Typography, TextField, Select, MenuItem, InputAdornment, IconButton, Stack, Modal, Table, TableHead, TableRow, TableCell, TableBody, Paper, FormControl, InputLabel, } from "@mui/material";
import searchIcon from "../../icons/searchIcon.svg"
import ThreeSixtyIcon from "@mui/icons-material/ThreeSixty";
import React, { useState, useEffect, useContext } from "react";
import clearFilterImage from "../../../src/icons/clearFilter.svg";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import * as XLSX from "xlsx";
import styled from "styled-components";
import Box from "@mui/material/Box";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import DeleteIcon from '@mui/icons-material/Delete';
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import { DataGrid, GridToolbarContainer, GridToolbarColumnsButton, GridToolbarFilterButton, GridToolbarDensitySelector, GridToolbarExport, GridDensitySelector, getGridStringOperators, } from "@mui/x-data-grid";
import { TABS, ROLES, DATE_FORMATS } from "../../constants";
import { Add, AddAPhoto, AddTask, SaveAlt, SaveAltOutlined, SaveAs, ManageSearch, Send, Search } from "@mui/icons-material";
import OpaqueLoading from "../../components/opaqueLoading/opaqueLoading";
import "../../App.css";
import { height } from "@mui/system";
import closeIcon from "../../icons/CloseIcon.svg"
import SwapConverIcon from "../../icons/sendEmail.svg"
import { set } from "date-fns";
const isMobile = window.innerWidth < 900;
const StaffEditorPageContainer = styled.div`
  height: ${isMobile ? `auto` : `calc(100vh - 105px)`};
  width: 100%;
  background-color: white;
  padding: 10px 15px;
  ${isMobile &&
    `
      position: relative;
      `}
`;
const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 7px;
`;
const TableContainer = styled.div`
  //   height: calc(
  //     100vh - ${isMobile
        ? "56px - 20px - 82.23px"
        : "128px - 29px - 50.77px"}
  //   );
  width: 100%;
  border: solid 1px lightGrey;
  border-radius: 8px;
`;
const DataGridContainer = styled.div`
  max-width: 100%; /* Add this line to limit the width */
  margin: 0 auto; /* Center the content horizontally */
  height: 100%;
  width: 100%;
  //   border: solid 1px lightGrey;
  display: ${isMobile ? "flex" : "grid"};
  border-radius: 4px;
  ${isMobile &&
    `
    flex-direction: column;
  `}
`;
const TabsContainer = styled.div`
  ${isMobile &&
    `
    height: calc(100vh - 56px - 20px - 43.77px);
  `}
`;
const OlympiadRegistration = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [paginationModel, setPaginationModel] = useState({ page: currentPage - 1, pageSize: 20, });
    const [rowCount, setRowCount] = useState();
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [rsms, setRsms] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [asms, setAsms] = useState([]);
    const [rms, setRms] = useState([]);
    const [rm, setRm] = useState("")
    const [rsm, setRsm] = useState("")
    const [asm, setAsm] = useState("")
    const [visibleEmployees, setVisibleEmployees] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pageSize, setPageSize] = useState(20)
    const [accessModulesData, setAccessModulesData] = useState([]);
    const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('storedUserData')).user)
    const [newOrderStatus, setNewOrderStatus] = useState("");
    const [automationStatus, setAutomationStatus] = useState("")
    const [filteredDate, setFilteredData] = useState({});
    const [modalData, setModalData] = useState([])
    const [openViewModal, setOpenViewModal] = useState(false)

    useEffect(() => {
        fetchSessions();
    }, []);

    const fetchSessions = async () => {
        try {
            setLoading(true);
            const response = await window.Platform.database.getAllSessions();
            // if (response?.data) {
            //   setSessions(response.data);
            // }
            if (response?.status) {
                const filterdData1 = response?.data?.filter((ele, ind) => ele?.action == "active")
                setFilteredData(filterdData1[0])
            }
            else {
                window.NotificationUtils.showError("Something Went Wrong in session")
            }
        } catch (error) {
            console.error("Error fetching sessions:", error);
            window.NotificationUtils.showError("Failed to load sessions");
        } finally {
            setLoading(false);
        }
    };

    // useEffect(() => {
    //     fetchEmployees();
    // }, [paginationModel.page, paginationModel.pageSize, newOrderStatus]);


    useEffect(() => {
        fetchAccessModules();
        if (userData?.role.toLowerCase().includes('admin')) {
            getAllUsers()
        }
        if (userData?.role == 'rsm') {
            getUsers('rsm', userData?.id)
        }
        if (userData?.role == 'asm') {
            getUsers('asm', userData?.id)
        }
    }, [])

    async function getAllUsers() {
        let results = await window.Platform.database.fetchEmployees()
        if (results?.status) {
            window.NotificationUtils.showError(results.message);
            setLoading(false);
            return;
        }
        else {
            setAllUsers(results?.data)
            setRsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'rsm'))
            setRms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'se'))
            setAsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'asm'))
            setLoading(false);
        }
    }

    async function getUsers(role, id) {
        if (id != "") {
            let results = await window.Platform.database.getUsersBasedOnManager({ userId: id })
            if (role == 'rsm') {
                setAsms(results?.data)
                setRms(results?.data1)
            }
            if (role == 'asm') {
                setRms(results?.data)
            }
        } else {
            if (role == 'rsm') {
                setRm("")
                setAsm("")
                setRms(allUsers?.filter((ele) => ele.role == 'se'))
                setAsms(allUsers?.filter((ele) => ele.role == 'asm'))
            }
            if (role == 'asm') {
                setRm("")
                setRms(allUsers?.filter((ele) => ele.role == 'se'))
            }
        }

    }

    const fetchAccessModules = async () => {
        try {
            setLoading(true);
            let data = {
                pageNumber: paginationModel.page,
                recordPerPage: paginationModel.pageSize,
                userId: userData?.id,
                moduleId: "2mcEyrlAXR"
            }
            let results = await window.Platform.database.fetchAccessModules(data);
            if (results?.status) {
                window.NotificationUtils.showError(results?.message || "Something went wrong");
                setLoading(false);
                return;
            }
            else {
                const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, idIndex: index + 1 }));
                setAccessModulesData(jsonArrayWithId);
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setLoading(false)
        }
    }

    const formatDate1 = (dateStr) => {
        if (!dateStr) return "N/A";

        const date = new Date(dateStr);

        if (isNaN(date)) return "N/A";

        return date.toLocaleString("en-IN", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };

    const handleOpenViewModal = (id) => {
        console.log(id, "isdsdsdsd")
        setModalData(id)
        setOpenViewModal(true);
    }

    const handleCloseViewModal = () => {
        setOpenViewModal(false);
        setModalData([]);
    }

    const getAllAddOns = (seriesObj) => {
        let addOns = Array.isArray(seriesObj?.add_ons)
            ? [...seriesObj.add_ons]
            : [];

        Object.keys(seriesObj || {}).forEach(key => {
            if (
                !["series_id", "subjects", "add_ons"].includes(key) &&
                typeof seriesObj[key] === "number"
            ) {
                addOns.push(`${key} (${seriesObj[key]})`);
            }
        });

        return addOns;
    };

    const groupedBySeries = {};

    modalData?.content_assignment?.forEach(cls => {
        cls.series?.forEach(ser => {
            const seriesKey = ser.series_id || "N/A";

            if (!groupedBySeries[seriesKey]) {
                groupedBySeries[seriesKey] = [];
            }

            groupedBySeries[seriesKey].push({
                class_name: cls.class_name,
                subjects: ser.subjects || [],
                add_ons: getAllAddOns(ser) // ✅ FIXED
            });
        });
    });

    const handleDownloadExcel = () => {
        try {
            if (!modalData) {
                window.NotificationUtils.showError("No data available to download.");
                return;
            }

            const classOrderMap = {
                "NURSERY": 1,
                "LKG": 2,
                "L K G": 2,
                "UKG": 3,
                "CLASS 1": 4,
                "CLASS 2": 5,
                "CLASS 3": 6,
                "CLASS 4": 7,
                "CLASS 5": 8,
                "CLASS 6": 9,
                "CLASS 7": 10,
                "CLASS 8": 11,
                "CLASS 9": 12,
                "CLASS 10": 13,
                "CLASS 11": 14,
                "CLASS 12": 15
            };

            // ✅ Normalize class names
            const normalizeClass = (name) =>
                (name || "")
                    .toUpperCase()
                    .replace(/[^A-Z0-9 ]/g, "")
                    .replace(/\s+/g, " ")
                    .trim();

            const rows = [];

            const address = [modalData?.AddressLine1, modalData?.AddressLine2]
                .filter(Boolean)
                .join(" ") || "N/A";

            // ================= BUILD ROWS =================
            if (groupedBySeries && Object.keys(groupedBySeries).length > 0) {

                Object.entries(groupedBySeries).forEach(([seriesName, classes]) => {
                    classes.forEach((cls) => {
                        rows.push({
                            "SO ID": modalData?.soid || "N/A",
                            "School ID": modalData?.school_id || "N/A",
                            "School Name": modalData?.school_name || "N/A",
                            "Address 1": modalData?.AddressLine1 || "N/A",
                            "Address 2": modalData?.AddressLine2 || "N/A",
                            "District": modalData?.District || "N/A",
                            "State": modalData?.State || "N/A",
                            "Pincode": modalData?.Pincode || "N/A",
                            "Board": modalData?.school_board || "N/A",
                            "Medium": modalData?.school_medium || "N/A",
                            "Grade": modalData?.grade || "N/A",
                            "Strength": modalData?.strength || "N/A",
                            "Website": modalData?.website || "N/A",
                            "Decision Maker": modalData?.decision_maker || "N/A",
                            "Decision Maker Mobile": modalData?.decision_maker_mobile_no || "N/A",
                            "Distributor ID": modalData?.distributor_id || "N/A",
                            "Distributor Name": modalData?.distributor_name || "N/A",
                            "Distributor Address 1": modalData?.distributor_address_1 || "N/A",
                            "Distributor Address 2": modalData?.distributor_address_2 || "N/A",
                            "RM Name": modalData?.rm_name || "N/A",
                            "RM Email": modalData?.rm_email || "N/A",
                            "RM Mobile": modalData?.rm_mobile || "N/A",
                            "Employee ID": modalData?.rm_employee_id || "N/A",
                            "Series Name": seriesName || "N/A",
                            "Class Name": cls?.class_name || "N/A",
                            "Subjects": (cls?.subjects || []).join(", ") || "N/A",
                            "Add-ons": cls?.add_ons?.length ? cls.add_ons.join(", ") : "N/A",
                            "LMS Status": modalData?.is_success?.toLowerCase() === "success" ? "Success" : "UnSuccess",
                            "Created At": formatDate1(modalData?.created_at) || "N/A",

                        });
                    });
                });

            } else {
                // fallback
                rows.push({
                    "SO ID": modalData?.soid || "N/A",
                    "School ID": modalData?.school_id || "N/A",
                    "School Name": modalData?.school_name || "N/A",
                    "Address 1": modalData?.AddressLine1 || "N/A",
                    "Address 2": modalData?.AddressLine2 || "N/A",
                    "District": modalData?.District || "N/A",
                    "State": modalData?.State || "N/A",
                    "Pincode": modalData?.Pincode || "N/A",
                    "Board": modalData?.school_board || "N/A",
                    "Medium": modalData?.school_medium || "N/A",
                    "Grade": modalData?.grade || "N/A",
                    "Strength": modalData?.strength || "N/A",
                    "Website": modalData?.website || "N/A",
                    "Decision Maker": modalData?.decision_maker || "N/A",
                    "Decision Maker Mobile": modalData?.decision_maker_mobile_no || "N/A",
                    "Distributor ID": modalData?.distributor_id || "N/A",
                    "Distributor Name": modalData?.distributor_name || "N/A",
                    "Distributor Address 1": modalData?.distributor_address_1 || "N/A",
                    "Distributor Address 2": modalData?.distributor_address_2 || "N/A",
                    "RM Name": modalData?.rm_name || "N/A",
                    "RM Email": modalData?.rm_email || "N/A",
                    "RM Mobile": modalData?.rm_mobile || "N/A",
                    "Employee ID": modalData?.rm_employee_id || "N/A",
                    "Series Name": "N/A",
                    "Class Name": "N/A",
                    "Subjects": "N/A",
                    "Add-ons": "N/A",
                    "LMS Status": modalData?.is_success?.toLowerCase() === "success" ? "Success" : "UnSuccess",
                    "Created At": formatDate1(modalData?.created_at) || "N/A",
                });
            }

            // ================= FINAL SORT (FIXED) =================
            rows.sort((a, b) => {
                // 1️⃣ Sort by Series Name
                if (a["Series Name"] !== b["Series Name"]) {
                    return (a["Series Name"] || "").localeCompare(b["Series Name"] || "");
                }

                // 2️⃣ Then sort by Class Order
                const orderA = classOrderMap[normalizeClass(a["Class Name"])] || 999;
                const orderB = classOrderMap[normalizeClass(b["Class Name"])] || 999;

                return orderA - orderB;
            });

            // ================= CREATE EXCEL =================
            const workbook = XLSX.utils.book_new();
            const worksheet = XLSX.utils.json_to_sheet(rows);

            XLSX.utils.book_append_sheet(workbook, worksheet, "Automation Logs");

            const fileName = `AutomationLogs_${modalData?.rm_employee_id || "Report"}.xlsx`;
            XLSX.writeFile(workbook, fileName);

        } catch (error) {
            console.error("Excel Download Error:", error);
            window.NotificationUtils.showError("Failed to download Excel file.");
        }
    };

    function CustomToolbar() {
        return (
            <>
                <GridToolbarContainer
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        flexWrap: "wrap"
                    }}
                >
                    <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                        <Button
                            onClick={() => { setNewOrderStatus(5) }}
                            style={{ backgroundColor: newOrderStatus === 5 ? "#8787f470" : "white", color: newOrderStatus === 5 ? "#000000" : "black", }} >
                            All
                        </Button>
                        <>
                            <Button
                                onClick={() => { setNewOrderStatus(0) }}
                                style={{
                                    backgroundColor: newOrderStatus === 0 ? "#fe9f13" : "white",
                                    color: newOrderStatus === 0 ? "white" : "black",
                                }}
                            >
                                Pending
                            </Button>
                            <Button
                                onClick={() => { setNewOrderStatus(1) }}
                                style={{
                                    backgroundColor: newOrderStatus === 1 ? "green" : "white",
                                    color: newOrderStatus === 1 ? "white" : "black",
                                }}
                            >
                                Approved
                            </Button>
                            <Button
                                onClick={() => { setNewOrderStatus(2) }}
                                style={{
                                    backgroundColor: newOrderStatus === 2 ? "red" : "white",
                                    color: newOrderStatus === 2 ? "white" : "black",
                                }}
                            >
                                Rejected
                            </Button>
                            <Button
                                onClick={() => { setNewOrderStatus(3) }}
                                style={{
                                    backgroundColor: newOrderStatus === 3 ? "#2196f3" : "white",
                                    color: newOrderStatus === 3 ? "white" : "black",
                                }}
                            >
                                Shipped
                            </Button>
                        </>
                        <Button
                            onClick={() => { setNewOrderStatus(4) }}
                            style={{
                                backgroundColor: newOrderStatus === 4 ? "#9c27b0" : "white",
                                color: newOrderStatus === 4 ? "white" : "black",
                            }}
                        >
                            Delivered
                        </Button>
                        <Button
                            onClick={() => { setNewOrderStatus(6) }}
                            style={{
                                backgroundColor: newOrderStatus === 6 ? "#757575" : "white",
                                color: newOrderStatus === 6 ? "white" : "black",
                            }}
                        >
                            Saved For Later
                        </Button>
                        <Button
                            onClick={() => { setNewOrderStatus(7) }}
                            style={{
                                backgroundColor: newOrderStatus === 7 ? "#f52727" : "#ffffff",
                                color: newOrderStatus === 7 ? "white" : "#000000",
                            }}
                        >
                            Deleted
                        </Button>
                    </div>

                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <Typography variant="body1" ml={3} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>Select Page Size:&nbsp; </Typography>
                        <Select
                            value={paginationModel.pageSize}
                            variant="outlined"
                            size="small"
                            onChange={(e) => { setPaginationModel({ ...paginationModel, pageSize: e.target.value }) }}
                            sx={{ width: 90, fontSize: 13, fontWeight: "500" }}
                        >
                            {[10, 20, 30, 50, 100].map((role) => (
                                <MenuItem key={role} value={role} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role}</MenuItem>
                            ))}
                        </Select>
                    </div>
                </GridToolbarContainer>

            </>
        );
    }

    const schoolColumns = () => {
        const stringOperators = getGridStringOperators().filter((op) =>
            ["contains"].includes(op.value)
        );

        let result = [
            {
                field: "empId1",
                headerName: "Emp ID",
                width: 100,
                filterable: false,
                sortable: false,
                valueGetter: (params) => {
                    let name = params.row.rm_employee_id || "N/A"
                    return name;
                },
                renderCell: (params) => {
                    let name = params.row.rm_employee_id || "N/A";
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    );
                },
            },
            {
                field: "name11",
                headerName: "Employee Name",
                width: 200,
                filterable: false,
                sortable: false,
                valueGetter: (params) => {
                    let name = params.row.rm_name || "N/A"
                    return name;
                },
                renderCell: (params) => {
                    let name = params.row.rm_name || "N/A";
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name}</Typography>
                        </Tooltip>
                    );
                },
            },
            {
                field: "createdAt1",
                headerName: "Created At",
                minWidth: 180,
                sortable: false,
                filterable: false,
                renderCell: (params) => {
                    return (
                        <Tooltip title={params.row.created_at || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}> {formatDate1(params.row.created_at) || "N/A"} </Typography>
                        </Tooltip>
                    );
                },
            },
            {
                field: "Action",
                headerName: "Actions",
                width: 200,
                filterable: false,
                sortable: false,
                renderCell: (params) => {
                    return (
                        <Stack direction={"row"} spacing={0}>
                            <Tooltip title="Click to view order items"><IconButton variant="extended" color="primary"
                            // onClick={(e) => {
                            //     e.stopPropagation();
                            //     fetchOrderLineItem(value);
                            // }} 
                            >
                                <RemoveRedEyeIcon />
                            </IconButton></Tooltip>
                            <Tooltip title="Click to edit order"><IconButton variant="extended"
                            // onClick={(e) => {

                            //     editData(allValues);
                            // }} 
                            >
                                <DriveFileRenameOutlineIcon sx={{ color: "black", fontSize: "22px", fontWeight: "500" }} />
                            </IconButton></Tooltip>
                            <Tooltip title="Click to approve order">
                                <IconButton
                                    disabled={params.row?.approvalStatus === 1 || params.row?.approvalStatus === 2}
                                    variant="extended"
                                    sx={{ color: "#008000" }}
                                // onClick={(e) => {
                                //     e.stopPropagation();
                                //     handleGeneratePayload(params.row);
                                // }}
                                >
                                    <ThumbUpIcon />
                                </IconButton>
                            </Tooltip>

                            <Tooltip title="Click to reject order">
                                <IconButton
                                    disabled={params.row?.approvalStatus === 1 || params.row?.approvalStatus === 2}
                                    variant="extended"
                                    sx={{ color: "red" }}
                                // onClick={(e) => {
                                //     e.stopPropagation();
                                //     handleReject({ id: value, ownerId });
                                // }}
                                >
                                    <ThumbDownIcon />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title={"Delete"}>
                                <IconButton
                                // onClick={() => handleDelete(params.row.orderId)} 
                                // disabled={params?.row?.is_deleted == 1}
                                >
                                    <DeleteIcon sx={{ color: "red", fontSize: "22px", fontWeight: "400" }} />
                                </IconButton>
                            </Tooltip>
                        </Stack>
                    )
                },
            },
        ].filter(Boolean);
        return result;
    };

    const exportAutomationLogsExcel = async () => {
        setLoading(true);
        try {
            let data = {
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm,
                ownerId: rm,
                startDate: startDate != '' ? startDate : filteredDate?.startDate,
                endDate: endDate != '' ? endDate : filteredDate?.endDate,
                is_success: automationStatus
            }
            let result = await window.Platform.database.exportData("order/downloadAutomationLogsExcel",
                data
            )
            const blob = new Blob([result.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const now = new Date();
            const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `AutomationLogs_Report_${formattedDate}.xlsx`);
            // link.setAttribute("download", "attendance.xlsx");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error("Export error:", error);
        }
    }

    const fetchEmployees = async () => {
        setLoading(true);
        try {
            setVisibleEmployees([]);

            let results = await window.Platform.database.getAutomationLogs({
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm,
                ownerId: rm,
                pageNumber: paginationModel.page,
                recordPerPage: paginationModel.pageSize,
                startDate: startDate != '' ? startDate : filteredDate?.startDate,
                endDate: endDate != '' ? endDate : filteredDate?.endDate,
                is_success: automationStatus
            });
            setRowCount(results?.total)

            const jsonArrayWithId = results?.data?.map((obj, index) => ({
                ...obj,
                id: index + 1,
            }));
            setVisibleEmployees(jsonArrayWithId);
            if (results.success) {
                setLoading(false);
            } else {
                setLoading(false);
                window.NotificationUtils.showError(results.message);
            }
        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    };

    const clearFilter = async () => {
        setNewOrderStatus("");
        setLoading(true);
        setRsm("");
        setAsm("");
        setRm("");
        setStartDate("")
        setEndDate("")
        setAutomationStatus("")
        setRsms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'rsm'));
        setRms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'se'));
        setAsms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'asm'));
        setVisibleEmployees([]);
        setRowCount(0);

        setLoading(false);
    };

    const renderTabContent = () => {
        return (<>
            <DataGridContainer
                style={{ height: !visibleEmployees.length ? "200px" : "auto" }}
            >
                <DataGrid
                    className="payrollGrid"
                    density="compact"
                    rows={visibleEmployees || []}
                    columns={schoolColumns()}
                    sx={{ color: "black", fontSize: "14px", fontWeight: "600" }}

                    disableSelectionOnClick
                    disableRowSelectionOnClick
                    rowHeight={60}
                    rowCount={rowCount}
                    paginationModel={paginationModel}
                    paginationMode="server"
                    onPaginationModelChange={setPaginationModel}
                    components={{
                        Toolbar: CustomToolbar,
                    }}
                />
            </DataGridContainer>
        </>
        );
    };

    return (
        <>
            <StaffEditorPageContainer>
                <HeaderContainer>
                    <Box sx={{ mt: 1, width: "100%" }}>
                        <Paper elevation={3}
                            sx={{
                                p: 2,
                                mb: 2,
                                width: '100%',        // takes full width of parent
                                // maxWidth: '1000px',   // optional: control max width
                                mx: 'auto',
                                backgroundColor: "#ebf0fa"          // center it horizontally
                            }}>
                            <div className="container-fluid" style={{ width: "100%" }}>
                                <div className="row">
                                    {userData?.role.includes('admin') && <div className="col-md-3">
                                        <FormControl fullWidth size="small">
                                            <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select HO</InputLabel>
                                            <Select
                                                value={rsm}
                                                label="Select HO"
                                                size="small"
                                                onChange={(e) => { setRsm(e.target.value); getUsers('rsm', e.target.value); setAsm(""); setRm("") }}
                                            >
                                                <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                                                {rsms.map((role) => (
                                                    <MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>}
                                    {userData?.role != 'asm' && <div className="col-md-3">
                                        <FormControl size="small" fullWidth>
                                            <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select ARM</InputLabel>
                                            <Select
                                                value={asm}
                                                label="Select ARM"
                                                size="small"
                                                onChange={(e) => { setAsm(e.target.value); getUsers('asm', e.target.value); setRm(""); }}
                                            >
                                                <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                                                {asms.map((role) => (
                                                    <MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>}
                                    <div className="col-md-3">
                                        <FormControl size="small" fullWidth>
                                            <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select RM:</InputLabel>
                                            <Select
                                                value={rm}
                                                label="Select RM"
                                                size="small"
                                                onChange={(e) => { setRm(e.target.value) }}
                                            >
                                                <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                                                {rms.map((role) => (
                                                    <MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    {accessModulesData && accessModulesData[0]?.is_download?.toLowerCase() != "no" && <div className="col-md-3">
                                        <Button variant="contained" color="success" startIcon={<FileDownloadIcon />} fullWidth sx={{ borderRadius: "10px" }}
                                        // onClick={() => { exportAutomationLogsExcel() }}
                                        >Download</Button>
                                    </div>}
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-3">
                                        <FormControl fullWidth size="small">
                                            <TextField label="From Date" size="small" type="date" sx={{ color: "black", fontSize: "13px", fontWeight: 500 }} className="form-control" value={startDate} onChange={(e) => setStartDate(e.target.value)}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: { color: "black", fontSize: "13px", fontWeight: 500 }
                                                }}
                                                inputProps={{
                                                    style: { color: "black", fontSize: "13px", fontWeight: 500 }
                                                }} />
                                        </FormControl>
                                    </div>
                                    <div className="col-md-3">
                                        <FormControl fullWidth size="small">
                                            <TextField label="To Date" size="small" type="date" sx={{ color: "black", fontSize: "13px", fontWeight: 500 }} className="form-control" value={endDate} onChange={(e) => setEndDate(e.target.value)}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: { color: "black", fontSize: "13px", fontWeight: 500 }
                                                }}
                                                inputProps={{
                                                    style: { color: "black", fontSize: "13px", fontWeight: 500 }
                                                }} />
                                        </FormControl>
                                    </div>
                                    <div className="col-md-3">
                                        <Button variant="contained" size="small" startIcon={<img src={searchIcon} alt="icon" height={"21"} width={"21"} />} color="primary" fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }}
                                        //  onClick={() => fetchEmployees()}
                                        >
                                            Find
                                        </Button>
                                    </div>
                                    <div className="col-md-3">
                                        <Button variant="contained" startIcon={<img src={clearFilterImage} alt="icon" height={"21"} width={"21"} />} color="secondary" size="small" fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => clearFilter()}>
                                            Clear Filters
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Paper>
                    </Box>
                </HeaderContainer>
                <TableContainer>
                    <TabsContainer>
                        {loading && <OpaqueLoading />}
                        {renderTabContent()}
                    </TabsContainer>
                </TableContainer>
            </StaffEditorPageContainer>
        </>
    );
};

export default OlympiadRegistration;
